"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var helper_1 = require("./helper");
var super_mario_yoshi_message_renderer_1 = __importDefault(require("@bit/super-mario.yoshi.message-renderer"));
require("./chatview.css");
var Twilio = require("twilio-chat");
var DEFAULT_COUNT = 10;
var ChatView = function (props) {
    var channelId = props.channelId, _a = props.count, count = _a === void 0 ? DEFAULT_COUNT : _a, _b = props.limit, limit = _b === void 0 ? true : _b;
    var _c = react_1.useState([]), messages = _c[0], setMessages = _c[1];
    react_1.default.useEffect(function () {
        var fn = function () { return __awaiter(void 0, void 0, void 0, function () {
            var token, client, channel, e_1, data, items, update;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, helper_1.getToken()];
                    case 1:
                        token = _a.sent();
                        return [4, Twilio.Client.create(token)];
                    case 2:
                        client = _a.sent();
                        return [4, client.getChannelBySid(channelId)];
                    case 3:
                        channel = _a.sent();
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4, channel.join()];
                    case 5:
                        _a.sent();
                        return [3, 7];
                    case 6:
                        e_1 = _a.sent();
                        return [3, 7];
                    case 7: return [4, channel.getMessages(25)];
                    case 8:
                        data = _a.sent();
                        if (!data)
                            return [2, null];
                        items = data.items;
                        if (!items)
                            return [2, null];
                        update = function (item) {
                            var state = item.state;
                            var author = state.author, body = state.body, sid = state.sid, timestamp = state.timestamp;
                            var _a = author.split("/"), userId = _a[0], name = _a.slice(1);
                            var message = {
                                id: sid,
                                userId: userId,
                                text: body,
                                timestamp: timestamp,
                            };
                            setMessages(function (messages) {
                                var arr = __spreadArrays(messages, [message]);
                                var msgs = limit === true ? arr.slice(-1 * count) : arr;
                                return msgs;
                            });
                        };
                        items.forEach(function (item) { return update(item); });
                        channel.on("messageAdded", function (item) { return update(item); });
                        return [2];
                }
            });
        }); };
        fn();
    }, []);
    var entries = messages.map(function (message) { return (react_1.default.createElement("li", { key: message.id },
        react_1.default.createElement(super_mario_yoshi_message_renderer_1.default, __assign({}, message)))); });
    return react_1.default.createElement("ul", { className: "chatview-container" }, entries);
};
exports.default = ChatView;
